import { Helmet } from "react-helmet-async"

import "../components/Homepage/Homepage.css"

import WhatIsAnHRA from "../components/Homepage/WhatIsAnHRA"
import ChooseHRA from "../components/Homepage/ChooseHRA"
import SalusionSimplifies from "../components/Homepage/salusion-simplifies/SalusionSimplifies"
import Testimonials from "../components/Homepage/testimonials/Testimonials"
import Benefits from "../components/Homepage/benefits/Benefits"
import Hra from "../components/Hra/HraContact"
import Hero from "../components/Homepage/Hero"

export default function Homepage() {
	const schema = {
		"@context": "https://schema.org",
		"@type": "Product",
		"name": "Simple & Affordable HRAs | Salusion",
		"description": "Salusion streamlines HRA administration for small businesses, delivering affordable, IRS‑compliant, tax‑free health benefits.",
		"brand": {
			"@type": "Brand",
			"name": "Salusion"
		},
		"offers": [
			{
				"@type": "Offer",
				"name": "ICHRA",
				"description": "Individual Coverage Health Reimbursement Arrangement (ICHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
			{
				"@type": "Offer",
				"name": "QSEHRA",
				"description": "Qualified Small Employer Health Reimbursement Arrangement (QSEHRA)",
				"price": "14.00",
				"priceCurrency": "USD",
				"availability": "https://schema.org/InStock",
				"priceSpecification": {
					"@type": "UnitPriceSpecification",
					"price": "14.00",
					"priceCurrency": "USD",
					"billingDuration": 1,
					"billingIncrement": 1,
					"unitCode": "MON",
					"unitText": "participant/month",
				},
				"eligibleQuantity": {
					"@type": "QuantitativeValue",
					"value": 1,
					"unitText": "participant"
				},
			},
		],
		"image": "https://salusion.com/assets/images/Generic.png",
		"url": "https://salusion.com",
	}
	return (
		<>
			<Helmet>
				<title>HRA Administration Software | Salusion</title>
				<meta name="title" content="HRA Administration Software | Salusion" />
				<meta name="description" content="Administer QSEHRAs and ICHRAs in minutes — compliant, automated, and affordable" />
				<meta name="keywords" content="Small Business HRA administration software, ICHRA, QSEHRA, Affordable HRA, tax-free benefit" />
				<link rel="canonical" href="https://salusion.com" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@Salusion" />
				<meta name="twitter:title" content="HRA Administration Software | Salusion" />
				<meta name="twitter:description" content="Administer QSEHRAs and ICHRAs in minutes — compliant, automated, and affordable" />
				<meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" />

				<meta property="og:title" content="HRA Administration Software | Salusion" />
				<meta property="og:description" content="Administer QSEHRAs and ICHRAs in minutes — compliant, automated, and affordable" />
				<meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta property="og:image:alt" content="Salusion logo and healthcare savings" />
				<meta property="og:url" content="https://salusion.com" />
				<meta property="og:type" content="website" />

				<script type="application/ld+json">{JSON.stringify(schema)}</script>
			</Helmet>
			<Hero />
			<WhatIsAnHRA />
			<ChooseHRA />
			<SalusionSimplifies />
			<Benefits />
			<Testimonials />
			<Hra />
		</>
	)
}
